module.exports = __webpack_public_path__ + "static/media/agreementIcon.d57ba73c.svg";